import styled from "styled-components";

export const ImageDiv = styled.img`
    width: 100%;
    height: 100%;
    display: ${(props) => (props.hideThumbDescBtn ? "none" : "")};
`;
